import { useEffect } from 'react';

import { RecoveryAction } from '../../utils/errorHandler';

import { useToast } from './ToastUtils';

/**
 * Component that listens for error events from the error handler
 * and displays them as toast notifications
 */
export const ErrorToastListener: React.FC = () => {
  const { showError } = useToast();

  useEffect(() => {
    const handleErrorToast = (event: CustomEvent) => {
      const { message, title, recoveryActions, persistent } = event.detail as {
        message: string;
        title?: string;
        recoveryActions?: RecoveryAction[];
        persistent?: boolean;
      };

      showError(message, title, recoveryActions, persistent);
    };

    // Listen for error toast events from the error handler
    window.addEventListener(
      'showErrorToast',
      handleErrorToast as EventListener
    );

    return () => {
      window.removeEventListener(
        'showErrorToast',
        handleErrorToast as EventListener
      );
    };
  }, [showError]);

  // This component doesn't render anything
  return null;
};
